import { FormatValueProps, formatValue as baseFormatValue, getAlternateString } from '@hb/react'
import { AlternateField, FieldTypes } from '@hb/shared'
import { FC } from 'react'
import { CopyTooltip } from '../components/CopyTooltip'

const formatValueComponents: Partial<Record<FieldTypes, FC<FormatValueProps>>> = {
  [FieldTypes.ALTERNATE]: ({ value, textOnly, field }) => {
    const asAltField = field as AlternateField
    if (value === undefined) return 'None'
    if (typeof value !== 'object') return value
    return textOnly ? (
      getAlternateString(value)
    ) : (
      <CopyTooltip
        prefix={`${asAltField?.altPrefix || 'Alt'}:`}
        label={value?.alternate || 'No alternate'}>
        {value?.main || 'None'}
      </CopyTooltip>
    )
  },
}

export const formatValue = ({ field, value, collections, textOnly }: FormatValueProps) => {
  if (field?.format) return field.format(value)
  const Component = field ? formatValueComponents[field.type] : null
  if (!Component) return baseFormatValue({ field, value, collections, textOnly })
  return <Component field={field} value={value} collections={collections} textOnly={textOnly} />
}
